<template>
  <div class="row q-col-gutter-xs" :class="classes">
    <div :class="autoWidth ? 'col-12' : 'col-auto'">
      <q-btn
        class="fit no-pointer-events no-scope-css"
        :style="{
          background: $helpers.getValue(data, 'color', '#ffffff'),
          color: $helpers.getValue(data, 'text_color', '#ffffff'),
        }"
        :size="size"
        dense
        unelevated
        :rounded="rounded"
        :label="$helpers.getValue(data, 'text', $ts('words.notAvailableShort'))"
      >
      </q-btn>
    </div>
    <div
      v-for="(sub, index) in data.sub"
      v-if="$helpers.getValue(data, 'sub', []).length > 0"
      :class="autoWidth ? 'col-12' : 'col-auto'"
    >
      <q-btn
        :key="`sub-type-${index}`"
        class="fit no-pointer-events no-scope-css"
        :size="size"
        :style="{
          background: $helpers.getValue(sub, 'color', '#ffffff'),
          color: $helpers.getValue(data, 'text_color', '#ffffff'),
        }"
        dense
        :rounded="rounded"
        unelevated
        :label="$helpers.getValue(sub, 'text', $ts('words.notAvailableShort'))"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: 'SaleType',
  props: {
    data: {
      type: Object,
    },
    autoWidth: {
      type: Boolean,
      default: true,
    },
    classes: {
      type: String,
    },
    size: {
      type: String,
      default: 'xs',
    },
    rounded: {
      type: Boolean,
      default: true,
    },
  },
}
</script>
